import { render } from "./PaginationBox.vue?vue&type=template&id=986b804c"
import script from "./PaginationBox.vue?vue&type=script&lang=js"
export * from "./PaginationBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/pagination/PaginationBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "986b804c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('986b804c', __exports__)) {
    api.reload('986b804c', __exports__)
  }
  
  module.hot.accept("./PaginationBox.vue?vue&type=template&id=986b804c", () => {
    api.rerender('986b804c', render)
  })

}


export default __exports__